import {
    TEMPLATE_MAPPING_START,
    TEMPLATE_MAPPING_DATA,
    TEMPLATE_MAPPING_END,
    TEMPLATE_MAPPING_EDIT,
    TEMPLATE_DB_FIELD
} from '../../slices/type';

interface InitState {
    data: any[]; 
    getByID: any[]; 
    getdbfield:any[];
    dataSingle: any[]; 
    loading: boolean;
}

const initState: InitState = {
    data: [],
    dataSingle: [],
    getdbfield:[],
    getByID:[],
    loading: false,
};

interface Action {
    type: string;
    payload?: any; 
    loading?: boolean;
}

const Template_Red = (state = initState, action: Action): InitState => {
    switch (action.type) {
        case TEMPLATE_MAPPING_START:
            return {
                ...state,
                loading: action.loading ?? false, 
            };
        case TEMPLATE_MAPPING_DATA:
            return {
                ...state,
                data: action.payload ?? [],
                loading: action.loading ?? false,
            };

           case TEMPLATE_DB_FIELD:
            return {
                ...state,
                getdbfield: action.payload ?? [],
                loading: action.loading ?? false,
            };    
            case TEMPLATE_MAPPING_EDIT:
            return {
                ...state,
                getByID: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case TEMPLATE_MAPPING_END:
            return {
                ...state,
                dataSingle: action.payload ?? [],
                loading: action.loading ?? false,
            };
        default:
            return state;
    }
};

export default Template_Red;
